import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-17649 — a booth kit: a pull-up, cards and a sign with their own lasting link and QR
 * code (`<base>/booth/a`). It is pointed at a show here and moved when the kit ships, so
 * nothing is reprinted and no visitor has to choose a show.
 */
@Index('IDX_trade_show_booth_kit_name', ['name'], { unique: true })
@Entity('trade_show_booth_kit')
export class TradeShowBoothKitEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 40 })
	public name!: string;

	@Column('int', { name: 'fk_trade_show__id', unsigned: true, nullable: true })
	public fkTradeShowId!: number | null;
}
